/*
 * Copyright (c) 2023. PublishPress, All rights reserved.
 */

export const SettingsForm = function (props) {
    return (
        <form method="post">
            {props.children}
        </form>
    )
}
